import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { motion } from 'motion/react';
import type { NavItem } from '../../lib/nav';

export function BottomNav({ items }: { items: NavItem[] }) {
  if (items.length === 0) return null;

  return (
    <nav className="glass fixed inset-x-3 bottom-[max(env(safe-area-inset-bottom),0.75rem)] z-40 mx-auto max-w-[700px] rounded-[26px] border border-hairline shadow-float md:hidden">
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to.split('/').length === 3}
            className={({ isActive }) =>
              clsx(
                'relative flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-medium transition-colors',
                isActive ? 'text-accent-strong' : 'text-faint',
              )
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative grid h-7 w-12 place-items-center">
                  {isActive && (
                    <motion.span
                      layoutId="bottomnav-active"
                      className="pointer-events-none absolute inset-0 rounded-none bg-accent-soft ring-1 ring-accent/10"
                      transition={{ type: 'spring', bounce: 0.2, duration: 0.45 }}
                    />
                  )}
                  <item.icon
                    className="relative z-10 size-[21px]"
                    strokeWidth={isActive ? 2.4 : 2}
                  />
                </span>
                {item.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
